module.exports = __webpack_public_path__ + "static/elf-sun-1-f59d8a155ac73dd475775d39d168eda1.webp";